// extracted by mini-css-extract-plugin
module.exports = {"nationalParksSwiper":"NationalParks_nationalParksSwiper__mIrZB","nationalParksDesktopCarousel":"NationalParks_nationalParksDesktopCarousel__JHCku"};